import CalculatorForm from './CalculatorForm'

const CalculatorFormContainer = props => {
  const updatedProps = {
    ...props
  }

  return <CalculatorForm {...updatedProps} />
}

export default CalculatorFormContainer
